import { Component, OnInit, Input } from '@angular/core';
import { BlogModel } from 'src/app/core/models/blog.model';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit { 

  @Input() blogData: BlogModel[] = [];
currentLang = localStorage.getItem('lang') || 'ar';

  constructor() { }

  ngOnInit(): void {
  }

}
